module.exports = __webpack_public_path__ + "img/5.dc2d61e1.jpg";